import { createApiSlice } from "@common";
import {
  CRUD_ORDER,
  CRUD_ORDER_ALERT,
  CRUD_ORDER_BY_ID,
  CRUD_ORDER_BY_OWNER,
} from "@routes";

const apiConfig = [
  {
    name: "addOrder",
    method: "post",
    url: CRUD_ORDER,
    stateKey: "message",
  },
  {
    name: "getOrder",
    method: "get",
    url: CRUD_ORDER,
    stateKey: "data",
  },
  {
    name: "getOrderByOwner",
    method: "get",
    url: CRUD_ORDER_BY_OWNER,
    stateKey: "data",
  },
  {
    name: "getOrderById",
    method: "get",
    url: CRUD_ORDER_BY_ID,
    stateKey: "details",
  },
  {
    name: "updateOrder",
    method: "put",
    url: CRUD_ORDER,
    stateKey: "message",
  },
  {
    name: "deleteOrder",
    method: "delete",
    url: CRUD_ORDER,
    stateKey: "message",
  },
  {
    name: "orderDeleteAlert",
    method: "get",
    url: CRUD_ORDER_ALERT,
    stateKey: "deleteAlert",
  },
];

const customReducers = {
  initialState: {
    data: [],
    details: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "order",
  apiConfig,
  customReducers
);

const orderSlice = slice;
export default orderSlice.reducer;

export const {
  addOrder,
  getOrder,
  getOrderByOwner,
  getOrderById,
  updateOrder,
  deleteOrder,
  orderDeleteAlert,
} = thunks;

export const { rowSelect } = actions;

